export const FETCH_STAYS_REQUEST = 'FETCH_STAYS_REQUEST';
export const FETCH_STAYS_SUCCESS = 'FETCH_STAYS_SUCCESS';
export const FETCH_STAYS_FAILURE = 'FETCH_STAYS_FAILURE';
